import { useState, useEffect } from 'react';

export function useAuthUser() {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    function fetchUser() {
      const base = window.VEDA_API_URL ?? '';
      fetch(`${base}/api/dashboard/auth-user`, {
        method: 'GET',
        credentials: 'include',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
        .then((data) => { if (!cancelled) { setUser(data); setReady(true); } })
        .catch((status) => {
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn('[useAuthUser] auth-user fetch failed, status:', status);
          }
          if (!cancelled) { setUser(null); setReady(true); }
        });
    }

    fetchUser();

    // Ascolta l'evento custom che Veda 3.5.1 dovrebbe emettere al login/logout
    window.addEventListener('veda:auth', fetchUser);

    return () => {
      cancelled = true;
      window.removeEventListener('veda:auth', fetchUser);
    };
  }, []);

  const can = (permission) =>
    user?.role === 'super-admin' || (user?.permissions ?? []).includes(permission);

  return { user, can, ready };
}
